import { createContext } from 'react';

import type { HotelReadCache } from './hotel_read_cache.js';

/** O cache de leitura do HOST que também alimenta a Página do Hotel. A lista o
 *  lê por contexto porque as duas são irmãs no host — o organismo não o recebe.
 *  Quais hotéis ficaram sem quarto sai dele pelo kit (`useSoldOutOfferIds`). */
export const HotelReadCacheContext = createContext<HotelReadCache | undefined>(undefined);
